
export const SOCKET_CONNECT = 'SOCKET_CONNECT';
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
export const SOCKET_CONNECT_STATUS = 'SOCKET_CONNECT_STATUS';
export const SOCKET_CONNECT_SUCCESS = 'SOCKET_CONNECT_SUCCESS';
export const SOCKET_CONNECT_FAILDED = 'SOCKET_CONNECT_FAILDED';
export const SOCKET_RECEIVE_MESSAGE = 'SOCKET_RECEIVE_MESSAGE';
export const SOCKET_EVENT_CONNECTED = 'connect';
export const SOCKET_EVENT_JOIN = 'join';
export const SOCKET_EVENT_JOIN_CHANNEL = 'join_channel';
export const SOCKET_EVENT_QUIT_CHANNEL = 'quit_channel';
export const SOCKET_EVENT_REMOVE_IC = 'remove_ic';
export const SOCKET_EVENT_CLOSE_CHANNEL = 'close_channel';
export const SOCKET_EVENT_REOPEN_CHANNEL = 'reopen_channel';
export const SOCKET_EVENT_MESSAGE = 'message';
export const SOCKET_EVENT_ATTACHMENT = 'attachment';
export const SOCKET_EVENT_MESSAGE_EDIT = 'message_edit';
export const SOCKET_EVENT_MESSAGE_DELETE = 'message_delete';
export const SOCKET_EVENT_ATTACHMENT_DELETE = 'attachment_delete';
export const SOCKET_EVENT_QUOTE_REQUEST = 'quote_request';
export const SOCKET_EVENT_MANDATE_REQUEST = 'mandate_request';
export const SOCKET_EVENT_CLOSE = 'close';
export const SOCKET_EVENT_OPEN = 'open';
export const SOCKET_EVENT_REOPEN = 'reopen';
export const SOCKET_EVENT_ASK_APPOINTMENT = 'ask_appointment';
export const SOCKET_EVENT_CONFIRM_APPOINTMENT = 'confirm_appointment';
export const SOCKET_EVENT_REJECT_APPOINTMENT = 'reject_appointment';
export const SOCKET_EVENT_DONE_APPOINTMENT = 'done_appointment';
export const SOCKET_EVENT_CANCEL_APPOINTMENT = 'cancel_appointment';
export const SOCKET_EVENT_NOTIFICATION_READ = 'notification-read';
export const SOCKET_TICKET_RECEIVE_MESSAGE = 'ticket/TICKET_ACTION_RECEIVE_MESSAGE';
export const SOCKET_TICKET_EDIT_MESSAGE = 'ticket/TICKET_ACTION_EDIT_MESSAGE';
export const SOCKET_TICKET_DELETE_MESSAGE = 'ticket/TICKET_ACTION_DELETE_MESSAGE';
export const TICKET_ACTION_RECEIVE_NOTIFICATION = `ticket/TICKET_ACTION_RECEIVE_NOTIFICATION`;
export const SOCKET_TICKET_SEND_MESSAGE = `ticket/SOCKET_SEND_MESSAGE`;
export const SOCKET_TICKET_GET_TICKET = `ticket/TICKET_GET_TICKET_NOTIFICATION`;
export const SOCKET_TICKET_GET_TICKET_CHANNEL = `ticket/TICKET_GET_TICKET_CHANNEL`;
export const SOCKET_TICKET_SET_TICKET_STATE = `ticket/TICKET_SET_TICKET_STATE`;
export const SOCKET_TICKET_SET_TICKET_APPOINTMENT = `ticket/TICKET_SET_TICKET_APPOINTMENT`;
export const SOCKET_TICKET_SET_TICKET_IN_LIST_REALTIME = `ticket/TICKET_SET_TICKET_IN_LIST_REALTIME`;
export const SOCKET_TICKET_SET_TICKET_AFTER_JOIN = `ticket/TICKET_SET_TICKET_AFTER_JOIN`;
export const SOCKET_TICKET_JOIN_CHANNEL = `ticket/TICKET_JOIN_CHANNEL`;
export const SOCKET_TICKET_QUIT_CHANNEL = `ticket/TICKET_QUIT_CHANNEL`;
export const SOCKET_TICKET_REMOVE_IC = `ticket/TICKET_REMOVE_IC`;
export const SOCKET_TICKET_CLOSE_CHANNEL = `ticket/TICKET_CLOSE_CHANNEL`;
export const SOCKET_TICKET_REOPEN_CHANNEL = `ticket/TICKET_REOPEN_CHANNEL`;

export const SOCKET_NOTIFICATION_SEND_MESSAGE = `notification/NOTIFICATION_RECEIVE_NOTIFICATION`;
export const NOTIFICATION_INCREASE_UNREAD_MESSAGE = `notification/NOTIFICATION_INCREASE_UNREAD_MESSAGE`;
export const NOTIFICATION_DECREASE_UNREAD_MESSAGE = `notification/NOTIFICATION_DECREASE_UNREAD_MESSAGE`;
export const TICKET_INCREASE_UNREAD_MESSAGE = 'ticket/TICKET_INCREASE_UNREAD_MESSAGE'
export const TICKET_EXTEND_SIDEBAR_TICKETS = 'ticket/TICKET_EXTEND_SIDEBAR_TICKETS'
export const SOCKET_TICKET_SET_TICKET_CHANNELS = 'ticket/TICKET_SET_TICKET_CHANNEL'

export const SOCKET_EVENT_ASK_JOIN = 'ask_join';
export const SOCKET_EVENT_CLOSE_INDEPENDENT_CONTRACTOR = 'close_independent_contractor';
export const SOCKET_EVENT_CLOSE_ADVERTISER = 'close_advertiser';
export const SOCKET_EVENT_MANDATE_INDEPENDENT_CONTRACTOR = 'mandate_independent_contractor';
export const SOCKET_EVENT_NEW_GROUP = 'new_group';
export const SOCKET_TICKET_INTERVENTION_REPORT = 'intervention_report';
export const SOCKET_NEW_NOTIFICATION = 'new_notification';
export const SOCKET_UPDATE_TICKET = 'update_ticket'
export const SOCKET_NEW_TICKET_ACTION = 'new_ticket_action'

export const SOCKET_ADD_BLOCK = 'add_block'
export const SOCKET_BLOCK_EXTEND_LIST = 'block/BLOCK_EXTEND_BLOCKS'
export const SOCKET_DELETE_BLOCK = 'delete_block'
export const SOCKET_BLOCK_SPLICE_LIST = 'block/BLOCK_SPLICE_BLOCKS'
export const SOCKET_UPDATE_BLOCK = 'update_block'
export const SOCKET_BLOCK_UPDATE_BLOCK_DASHBOARD= 'block/BLOCK_SET_BLOCK'
export const SOCKET_BLOCK_UPDATE_LIST = 'block/BLOCK_UPDATE_BLOCKS'

export const SOCKET_ADD_APARTMENT = 'add_apartment'
export const SOCKET_APARTMENT_EXTEND_LIST = 'apartment/APARTMENT_EXTEND_APARTMENTS'
export const SOCKET_APARTMENT_EXTEND_SIDEBAR_LIST = 'apartment/APARTMENT_EXTEND_SIDEBAR_APARTMENTS'
export const SOCKET_APARTMENT_INCREMENT_COUNT = 'block/BLOCK_INCREMENT_TOTAL_APARTMENT'
export const SOCKET_DELETE_APARTMENT = 'delete_apartment'
export const SOCKET_APARTMENT_SPLICE_LIST = 'apartment/APARTMENT_SPLICE_APARTMENTS'
export const SOCKET_APARTMENT_SPLICE_SIDEBAR_LIST = 'apartment/APARTMENT_SPLICE_SIDEBAR_APARTMENTS'
export const SOCKET_APARTMENT_DECREMENT_COUNT = 'block/BLOCK_DECREMENT_TOTAL_APARTMENT'
export const SOCKET_UPDATE_APARTMENT = 'update_apartment'
export const SOCKET_APARTMENT_UPDATE_APARTMENT_DASHBOARD = 'apartment/APARTMENT_SET_APPARTMENT'
export const SOCKET_APARTMENT_UPDATE_LIST = 'apartment/APARTMENT_UPDATE_APARTMENTS'
export const SOCKET_APARTMENT_UPDATE_SIDEBAR_LIST = 'apartment/APARTMENT_UPDATE_SIDEBAR_APARTMENTS'


export const SOCKET_ADD_USER = 'add_user'
export const SOCKET_MEMBERS_EXTEND_LIST = 'profile/PROFILE_EXTEND_MEMBERS'
export const SOCKET_DELETE_USER = 'delete_user'
export const SOCKET_MEMBERS_SPLICE_LIST = 'profile/PROFILE_SPLICE_MEMBERS'
export const SOCKET_UPDATE_USER = 'update_user'
export const SOCKET_MEMBERS_UPDATE_LIST = 'profile/PROFILE_UPDATE_MEMBERS'
export const SOCKET_USER_UPDATE_DETAILS = 'user/USER_INFO_PATCH'


// WEBPACK FOOTER //
// ./src/store/_plugin/socket-types.plugin.ts